import AuthInputByType from "./AuthInputByType"

export default AuthInputByType
